import request from '@/utils/request'

const previewURL = {
  Created: '/article-preview/create',
  Detail: '/article-preview/view',
  List: '/article-preview/list',
  Delete: '/article-preview/delete',
  Update: '/article-preview/update'
}

// 新建-预览
export function createPreview (data) {
  return request({
    url: previewURL.Created,
    method: 'post',
    data
  })
}

// 详情-预览
export function detailPreview (data) {
  return request({
    url: previewURL.Detail,
    method: 'post',
    data
  })
}

// 列表-预览
export function listPreview (data) {
  return request({
    url: previewURL.List,
    method: 'post',
    data
  })
}

// 更新-预览
export function updatePreview (data) {
  return request({
    url: previewURL.Update,
    method: 'post',
    data
  })
}

// 删除-预览
export function deletePreview (data) {
  return request({
    url: previewURL.Delete,
    method: 'post',
    data
  })
}

export default {
  listPreview,
  createPreview,
  detailPreview,
  updatePreview,
  deletePreview
}
